/*
 * 生产日期录入
 * */
export const GETPRODUCTDATELIST = 'GETPRODUCTDATELIST' // 获取生产日期配置列表
export const GETUNPRODUCTDATEDETAILLIST = 'GETUNPRODUCTDATEDETAILLIST' // 获取未配置的生产日期详情
export const GETPRODUCTDATEDETAILLIST = 'GETPRODUCTDATEDETAILLIST' // 获取已配置的生产日期详情 少了un
export const SAVEPRODUCTIONDATECONFIGURATION = 'SAVEPRODUCTIONDATECONFIGURATION' // 保存生产日期配置

/*
 * 上架单
 * */
export const GETSHELVESORDERLIST = 'GETSHELVESORDERLIST' // 获取上架单列表
export const CANCELSHELVESORDER = 'CANCELSHELVESORDER' // 获取上架单详情
export const GETSHELVESORDERINFO = 'GETSHELVESORDERINFO' // 获取上架单详情
export const GETPRODUCTLIST = 'GETPRODUCTLIST' // 获取商品列表
export const SAVESHELVESORDER = 'SAVESHELVESORDER' // 保存上架单
export const GETSHELVESDOCUMENTSSUPPLIERSELECT = 'GETSHELVESDOCUMENTSSUPPLIERSELECT' // 保存上架单

/*
 * 快速移库
 * */
export const GETMOVETASKLIST = 'GETMOVETASKLIST' // 获取快速移库列表
export const GETMOVETASKDETAIL = 'GETMOVETASKDETAIL' // 获取移库任务详情
/**
 * 品质调整
 */
export const GETQUALITYLOG = 'GETQUALITYLOG'
/**
 * 生产日期调整
 */
export const GETDATELOG = 'GETDATELOG'



// WEBPACK FOOTER //
// ./src/store/rollsHomework/types.js